
  <ng-container *ngIf="!field.templateOptions.hidden">
  <div class="row">
      <div class="col col-12 p-4 pb-0"><!--  text-center font-weight-bold-->
      <p class="font-weight-bold mb-1">Owner</p>
      <p class="text-muted m-0">
        You can assign, unassign or modify who is the owner that will receive the notification for this job offer.
        </p>
      </div>
      <!--
      <div class="col col-6 pl-4">
        <span class="font-weight-bold">Current Owner: </span>
        {{
          watcher
            ? watcher.email
            : "No owner assigned, select someone from the box down below."
        }}
        <div class="d-none">
          <div
            *ngFor="let op of operators"
            (click)="assignTo = op.id"
            class="clickable"
            [ngClass]="{ 'font-weight-bold': op.id === assignTo }"
          >
            {{ op.email }}
          </div>
        </div>
      </div>
      <div class="col col-6 pr-4">
        <span class="font-weight-bold">New Owner: </span>
        {{
          assignTo
            ? assignToEmail
            : "No owner assigned, select someone from the box down below."
        }}
        <div class="d-none">
          <div
            *ngFor="let op of operators"
            (click)="assignTo = op.id"
            class="clickable"
            [ngClass]="{ 'font-weight-bold': op.id === assignTo }"
          >
            {{ op.email }}
          </div>
        </div>
      </div>
      -->
      <div class="col col-12 mt-1">
        <ng-select
          #s
          [items]="operators"
          bindLabel="email"
          bindValue="id"
          [hideSelected]="true"
          typeToSearchText="Please enter 2 or more characters"
          [(ngModel)]="assignTo"
          [placeholder]="'Select ...'"
          [closeOnSelect]="true"
          (change)="submit($event)"
          dropdownPosition="bottom"
        >
          <!-- <ng-template ng-label-tmp></ng-template> -->
          <ng-template ng-header-tmp> </ng-template>
          <!-- <ng-template ng-option-tmp let-item="item">
        <i class="fa fa-plus color-blue"></i> {{ item.name }}
      </ng-template> -->
        </ng-select>
      </div>
      <!-- <div class="col">
        <div>
          <div
            (click)="assignTo = 'unassigned'"
            class="clickable"
            [ngClass]="{ 'font-weight-bold': 'unassigned' === assignTo }"
          >
            Unassign
          </div>
        </div>
      </div> -->
      <!--
      <div class="col col-12 align-items-center text-center mt-4" *ngIf="!field.templateOptions.submitDisabled">
        <button
          class="btn btn-secondary mr-4 d-inline-flex"
          (click)="modalRef.hide()"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary d-inline-flex"
          (click)="submit()"
          [disabled]="!assignTo"
        >
          Save
        </button>
      </div>
      -->
    </div>
  </ng-container>
    <!-- <input type="input" [formControl]="formControl" [formlyAttributes]="field"> -->
    <!-- <button
      type="submit"
      class="{{
        field.templateOptions.className
          ? field.templateOptions.className
          : 'btn btn-default'
      }}"
      [disabled]="field.templateOptions.disabled || form.invalid"
    >
      {{ field.templateOptions.buttonLabel }}
    </button> -->
    <!-- {{ field.templateOptions.disabled}} -->
  